import { render, staticRenderFns } from "./Seleccion.vue?vue&type=template&id=06daeaaf&scoped=true&"
import script from "./Seleccion.vue?vue&type=script&lang=js&"
export * from "./Seleccion.vue?vue&type=script&lang=js&"
import style0 from "./Seleccion.vue?vue&type=style&index=0&id=06daeaaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06daeaaf",
  null
  
)

export default component.exports